import { createFileRoute } from "@tanstack/react-router";
import { StudioPage } from "lib/components/studio/StudioPage";
import withAuthentication from "../components/withAuthentication";

export const Route = createFileRoute("/studio")({
  component: withAuthentication(StudioPage, { permissions: ["VIEW_STUDIO_FILES"], products: ["studio"] }),
});
